<template>
  <div>
    <!-- 搜索表单区域 -->
    <el-form :model="query" label-width="90px" inline size="mini">
      <el-form-item label="员工信息">
        <el-input placeholder="请输入员工信息" v-model="query.staff" clearable></el-input>
      </el-form-item>
      <el-form-item label="代理信息">
        <el-input placeholder="请输入代理信息" v-model="query.agent" clearable></el-input>
      </el-form-item>
      <!-- 创建时间 -->
      <el-form-item label="创建时间">
        <el-date-picker
          v-model="period"
          value-format="yyyy-MM-dd"
          unlink-panels
          type="daterange"
          range-separator="至"
          start-placeholder="创建开始日期"
          end-placeholder="创建结束日期"
        ></el-date-picker>
      </el-form-item>
      <el-button type="primary" @click="search" size="mini">搜索</el-button>
    </el-form>
    <!-- 卡片视图区域 -->
    <el-card class="box-card">
      <!-- 数据展示区域 -->
      <el-table :data="staffList" style="width: 100%" height="650px" stripe border="" :cell-style="cellStyle" :header-cell-style="cellStyle">
        <el-table-column type="index"></el-table-column>
        <!-- <el-table-column prop="uuid" label="员工ID" width="160"></el-table-column> -->
        <el-table-column prop="nickname" label="员工昵称"></el-table-column>
        <el-table-column prop="cellphone" label="员工手机号" width="120"></el-table-column>
        <el-table-column prop="breadProfitRate" label="分润比例" width="100" align="right">
          <template slot-scope="scope">{{scope.row.profitRate}} %</template>
        </el-table-column>
        <el-table-column prop="totalMoney" label="总收益/元" width="145" align="right">
          <template slot-scope="scope">
            <div class="numberingBox" @click="openWallet(scope.row)">
              {{scope.row.totalMoney}}
              <i class="el-icon-coin"></i>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="unusedMoney" label="余额/元" width="125" align="right"></el-table-column>
        <el-table-column prop="createTime" label="开通时间" width="150"></el-table-column>
        <el-table-column prop="agentNickname" label="代理昵称"></el-table-column>
        <el-table-column prop="agentCellphone" label="代理手机号" width="120" style="background: #fdf5e6;"></el-table-column>
        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <el-tooltip effect="dark" content="手机号变更记录" placement="bottom-start">
              <el-button type="primary" icon="el-icon-phone" size="mini" @click="editCellphone(scope.row.uuid)"></el-button>
            </el-tooltip>
            <el-tooltip effect="dark" content="调整员工分润" placement="bottom-start">
              <el-button type="info" icon="el-icon-edit" size="mini" @click="editProfitRate(scope.row.uuid)"></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页功能 -->
      <el-pagination
        @size-change="pageSizeChange"
        @current-change="CurrentPageChange"
        :current-page="query.curPage"
        :page-sizes="[5, 10, 15]"
        :page-size="query.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalSize"
      ></el-pagination>
    </el-card>
    <!-- 修改手机号码对话框 -->
    <el-dialog title="手机号变更记录" :visible.sync="mdCellphoneDialogVisible" width="35%">
      <div>
        <!-- 手机号码历史记录 -->
        <el-table :data="cellphoneList" style="width: 100%" stripe border="">
          <el-table-column type="index"></el-table-column>
          <el-table-column prop="createTime" label="变更时间"></el-table-column>
          <el-table-column prop="beforeInfo" label="变更前手机号码"></el-table-column>
          <el-table-column prop="afterInfo" label="变更后手机号码"></el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <!-- 修改代理分润对话框 -->
    <el-dialog title="修改员工分润" :visible.sync="profitRateDialogVisible" @close="close('profitRateRef')" width="50%">
      <div>
        <el-form ref="profitRateRef" :model="profitRateForm" :rules="profitRateRules" label-width="150px" class="profitRateForm">
          <el-form-item label="分润比例" prop="profitRate">
            <el-input v-model="profitRateForm.profitRate" type="number" :placeholder="'范围 ' + profitRange.minRate + ' ~ ' + profitRange.maxRate"></el-input>
          </el-form-item>
        </el-form>
        <!-- 收益比例变更记录 -->
        <el-table :data="profitInfoList" style="width: 100%" border="" stripe>
          <el-table-column type="index"></el-table-column>
          <el-table-column prop="createTime" label="变更时间" width="150"></el-table-column>
          <el-table-column label="变更前分润(%)">
            <template slot-scope="scope">{{scope.row.beforeInfo*100}}</template>
          </el-table-column>
          <el-table-column label="变更后分润(%)">
              <template slot-scope="scope">{{scope.row.afterInfo*100}}</template>
          </el-table-column>
          <!-- <el-table-column prop="remark" label="备注" width="180"></el-table-column> -->
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="profitRateDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="editProfitRateBtn">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="员工钱包 (Esc 退出)" :visible.sync="walletDialogVisible" fullscreen>
      <div class="wallet">
        <el-row :gutter="60">
          <el-col :span="9">
            <div class="topBox">
              <div>
                <el-form label-position="left" label-width="100px" inline class="expand">
                  <el-form-item label="员工昵称:">
                    <span>{{staff.nickname}}</span>
                  </el-form-item>
                  <el-form-item label="员工手机:">
                    <span>{{staff.cellphone}}</span>
                  </el-form-item>

                  <el-form-item label="是否已认证:">
                    <span v-if="wallet.isAuth === 1">是</span>
                    <span v-else>否</span>
                    <el-button style="margin-left: 20px;" type="warning" size="mini" @click="editAuth()">认证记录</el-button>
                  </el-form-item>
                  <el-form-item label="是否可提现:">
                    <span v-if="wallet.canWithdraw === 1">是</span>
                    <span v-else>否</span>
                    <el-button style="margin-left: 20px;" type="danger" size="mini" @click="editWithdraw()">修改提现状态</el-button>
                  </el-form-item>

                  <el-form-item label="历史总收益:">
                    <span>{{wallet.totalMoney}}元</span>
                  </el-form-item>
                  <el-form-item label="可提现金额:">
                    <span>{{wallet.unusedMoney}}元</span>
                  </el-form-item>
                  <el-form-item label="已提现金额:">
                    <span>{{wallet.usedMoney}}元</span>
                  </el-form-item>
                </el-form>
              </div>
            </div>
            <!-- 折线图区域 -->
            <div class="bottom">
              <p>代理周收益</p>
              <div class="charts" ref="charts" id="charts"></div>
            </div>
          </el-col>
          <!-- 右边区域 -->
          <el-col :span="15">
            <!-- 卡片视图区域 -->
            <el-card>
              <!-- 搜索表单区域 -->
              <el-form :model="queryIncome" label-width="90px" inline size="mini">
                <el-form-item label="创建时间">
                  <el-date-picker
                    v-model="periodIncome"
                    type="daterange"
                    align="right"
                    unlink-panels
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :picker-options="pickerOptions"
                  ></el-date-picker>
                </el-form-item>
                <!-- <el-button class="resetBtn" type="warning" size="mini" @click="custodyIncome">重置</el-button> -->
                <el-button type="primary" size="mini" @click="searchIncome">搜索</el-button>
                <el-button type="success" size="mini" @click="excelDetail">明细导出</el-button>
              </el-form>
              <!-- 表格数据展示区域 -->
              <el-table :data="incomeList" style="width: 100%;" height="650px" border="" stripe>
                <!-- 展开行区域 -->
                <el-table-column type="expand">
                  <template slot-scope="scope">
                    <el-form label-width="90px" label-position="left" class="expand">
                      <el-form-item label="员工标识">
                        <span>{{ scope.row.sourceUuid }}</span>
                      </el-form-item>
                      <el-form-item label="钱包标识">
                        <span>{{ scope.row.walletUuid }}</span>
                      </el-form-item>
                      <el-form-item label="租凭订单号">
                        <span>{{ scope.row.leaseOrderUuid }}</span>
                      </el-form-item>
                      <el-form-item label="支付订单号">
                        <span>{{ scope.row.payOrderUuid }}</span>
                      </el-form-item>
                      <el-form-item label="备注">
                        <span>{{ scope.row.remark }}</span>
                      </el-form-item>
                    </el-form>
                  </template>
                </el-table-column>
                <el-table-column type="index"></el-table-column>
                <el-table-column prop="uuid" label="流水号" width="235"></el-table-column>
                <el-table-column prop="amount" label="流水金额(元)"></el-table-column>
                <el-table-column prop="lastAmount" label="钱包余额(元)"></el-table-column>
                <el-table-column prop="createTime" label="创建时间"></el-table-column>
                <el-table-column prop="port" label="出入账">
                  <template slot-scope="scope">
                    <span v-if="scope.row.port === 1">入账</span>
                    <span v-else-if="scope.row.port === -1">出账</span>
                    <span v-else></span>
                  </template>
                </el-table-column>
                <el-table-column prop="type" label="类型">
                  <template slot-scope="scope">
                    <span v-if="scope.row.type === 3">收益扣款</span>
                    <span v-else-if="scope.row.type === 4">使用收益</span>
                    <span v-else-if="scope.row.type === 5">收益提现</span>
                    <span v-else-if="scope.row.type === 15">提现回退</span>
                    <span v-else-if="scope.row.type === 31">转账</span>
                  </template>
                </el-table-column>
              </el-table>
              <!-- 分页区域 -->
              <el-pagination
                @size-change="pageSizeChangeIncome"
                @current-change="CurrentPageChangeIncome"
                :current-page="queryIncome.curPage"
                :page-sizes="[5, 10, 15]"
                :page-size="queryIncome.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalSizeIncome"
              ></el-pagination>
            </el-card>
          </el-col>
        </el-row>
        <!-- 认证状态对话框 -->
        <el-dialog title="认证状态信息" :visible.sync="authDialogVisible" width="70%" append-to-body>
          <div>
            <el-table :data="authList" style="width: 100%" border="" stripe>
              <el-table-column prop="uuid" label="">
                <template slot-scope="scope">
                  <el-tag type="success" v-if="scope.row.uuid===wallet.authUuid">当前认证</el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="name" label="姓名"></el-table-column>
              <el-table-column prop="cardNo" label="身份证号码"></el-table-column>
              <!-- <el-table-column prop="bankAccountNo" label="银行卡号码"></el-table-column> -->
              <el-table-column prop="bankPreCellphone" label="预留手机号"></el-table-column>
              <el-table-column label="认证状态" width="80">
                <template slot-scope="scope">
                  <el-tag type="success" v-if="scope.row.status===1">成功</el-tag>
                  <el-tag type="info" v-else>失败</el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="createTime" label="认证时间"></el-table-column>
              <el-table-column label="操作" width="100" v-if="wallet.isAuth===0">
                <template slot-scope="scope">
                  <el-button type="warning" size="mini" @click="authConfirm(scope.row.uuid)">确认认证</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button v-if="wallet.isAuth===1" type="danger" class="authBtn" @click="authCancel">解除认证</el-button>
            <!-- <el-button type="primary" @click="authDialogVisible = false">关 闭</el-button> -->
          </span>
        </el-dialog>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { list, cellphoneList, profitList, profit, wallet, week, statement, excel, cancelCredit, creditList, withdraw, confirmCredit } from '@/API/staff'
import echarts from 'echarts'
export default {
  name: 'proxy',
  data() {
    return {
      query: {
        // 页码
        curPage: 1,
        // 显示数量
        pageSize: 10,
        // 创建时间
        ctend: '',
        // 结束时间
        ctStart: '',
        // 是否认证 0未认证 1已认证
        isAuth: '',
        // 代理手机号码
        cellphone: '',
        // 推荐人手机号码
        parentCellphone: '',
        nickname: '',
        agent: '',
        staff: ''
      },
      // 时间段
      period: [],
      // 总数据条数
      totalSize: 0,
      // 代理数据列表
      staffList: [],
      // 修改手机号码历史记录
      mdCellphoneDialogVisible: false,
      // 修改手机号码历史记录
      cellphoneList: [],
      // 代理分润对话框是否显示
      profitRateDialogVisible: false,
      // 代理分润表单数据
      profitRateForm: {
        profitRate: '',
        staffUuid: ''
      },
      profitRateRules: {
        profitRate: [{ required: true, message: '请输入分润比例', trigger: 'blur' }]
      },
      // 收益比例变更记录
      profitInfoList: [],
      profitRange: {
        minRate: 0,
        maxRate: 0
      },

      walletDialogVisible: false,
      authDialogVisible: false,
      authList: [],
      walletUuid: '',
      staff: {
        uid: '',
        nickname: '',
        cellphone: ''
      },
      wallet: {
        authUuid: '',
        isAuth: 0,
        canWithdraw: 0,
        totalMoney: 0,
        usedMoney: 0,
        unusedMoney: 0
      },
      periodIncome: [],
      queryIncome: {
        walletUuid: '',
        sourceType: '12',
        curPage: 1,
        pageSize: 10,
        ctStart: '',
        ctEnd: ''
      },
      // 收益明细
      incomeList: [],
      totalSizeIncome: 0,
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      // ecarts配置数据
      option: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross'
          }
        },
        xAxis: {
          name: '日期',
          nameTextStyle: {
            fontWeight: 700,
            fontSize: 18
          },
          type: 'category',
          boundaryGap: false,
          data: []
        },
        yAxis: {
          name: '收益(元)',
          nameTextStyle: {
            fontWeight: 700,
            fontSize: 18
          },
          type: 'value'
        },
        series: [
          {
            color: {
              type: 'linear',
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
                {
                  offset: 0,
                  color: 'red' // 0% 处的颜色
                },
                {
                  offset: 1,
                  color: 'blue' // 100% 处的颜色
                }
              ],
              global: false // 缺省为 false
            },
            data: [],
            type: 'line',
            areaStyle: {}
          }
        ]
      },
      agentSelect: []
    }
  },
  created() {
    this.getStaffList()
  },
  methods: {
    // 获取代理列表数据
    async getStaffList() {
      const { data: res } = await list(this.query)
      if (res.code !== 200) return this.$message.error(res.message)
      this.staffList = res.data.entities
      this.totalSize = res.data.totalSize
    },
    // 搜索按钮点击触发
    search() {
      this.query.curPage = 1
      if (this.period != null && this.period !== []) {
        this.query.ctStart = this.period[0]
        this.query.ctEnd = this.period[1]
      } else {
        this.query.ctStart = ''
        this.query.ctEnd = ''
      }
      this.getStaffList()
    },
    // 重置按钮点击触发
    custody() {
      this.period = []
      this.query = {
        curPage: 1,
        pageSize: 10
      }
      this.getStaffList()
    },
    // 监听pageSize的变化
    pageSizeChange(newSize) {
      this.query.pageSize = newSize
      this.getStaffList()
    },
    // 监听当前页码值的变化
    CurrentPageChange(newPage) {
      this.query.curPage = newPage
      this.getStaffList()
    },
    // 点击修改手机号码按钮显示对话框
    editCellphone(uuid) {
      this.cellphoneList = []
      this.mdCellphoneDialogVisible = true
      this.getCellphonerec(uuid)
    },
    // 获取手机号码记录
    async getCellphonerec(uuid) {
      const { data: res } = await cellphoneList({ staffUuid: uuid })
      if (res.code !== 200) return this.$message.error(res.message)
      this.cellphoneList = res.data
    },

    // 获取收益比例变更记录
    async getprofitList(uuid) {
      const { data: res } = await profitList({ staffUuid: uuid })
      if (res.code !== 200) return this.$message.error(res.message)
      this.profitInfoList = res.data
    },
    // 点击代理分润触发
    editProfitRate(uuid) {
      this.profitInfoList = []
      this.profitRange = {
        minRate: 0,
        maxRate: 100
      }
      this.profitRateForm.staffUuid = uuid
      this.getprofitList(uuid)
      this.profitRateDialogVisible = true
    },
    // 调整代理分润
    async editProfitRateBtn() {
      this.$refs.profitRateRef.validate(async valid => {
        if (!valid) return
        const { data: res } = await profit(this.profitRateForm)
        if (res.code === 200) {
          this.$message.success(res.message)
          this.$refs.profitRateRef.resetFields()
          this.profitRateDialogVisible = false
          this.getStaffList()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    close(formRef) {
      this.$refs[formRef].resetFields()
    },
    // 进入钱包
    async openWallet(row) {
      this.authList = []
      this.periodIncome = []
      this.incomeList = []
      this.totalSizeIncome = 0
      this.walletUuid = row.walletUuid
      this.queryIncome.walletUuid = row.walletUuid
      this.staff.nickname = row.nickname
      this.staff.cellphone = row.cellphone

      this.getWalletInfo()

      this.walletDialogVisible = true
      // 获取代理周收益数据
      const { data: res } = await week({
        walletUuid: this.walletUuid
      })
      if (res.code !== 200) return this.$message.error(res.message)
      this.option.xAxis.data = res.data.weekProfit.map(item => {
        return item.dateStr
      })
      this.option.series[0].data = res.data.weekProfit.map(item => {
        return item.profit
      })

      let charts = this.$refs.charts
      let myChart = echarts.init(charts)
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(this.option)
    },
    async getAuth() {
      const { data: res } = await creditList({ walletUuid: this.walletUuid })
      if (res.code !== 200) return this.$message.error(res.message)
      this.authList = res.data
    },
    authConfirm(creditUuid) {
      this.$confirm('此操作将确认认证, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const { data: res } = await confirmCredit({
          walletUuid: this.walletUuid,
          creditUuid: creditUuid
        })
        if (res.code !== 200) return this.$message.error(res.message)
        this.$message.success(res.message)
        this.wallet.isAuth = 1
        this.wallet.authUuid = creditUuid
      })
    },
    authCancel() {
      this.$confirm('此操作将解除认证, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const { data: res } = await cancelCredit({ walletUuid: this.walletUuid })
        if (res.code !== 200) return this.$message.error(res.message)
        this.$message.success(res.message)
        this.wallet.isAuth = 0
        this.wallet.authUuid = ''
      })
    },
    editAuth() {
      this.getAuth()
      this.authDialogVisible = true
    },
    editWithdraw() {
      this.$confirm('此操作将更改是否可提现, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const { data: res } = await withdraw({
          canWithdraw: !this.wallet.canWithdraw + 0,
          walletUuid: this.walletUuid
        })
        if (res.code !== 200) return this.$message.error(res.message)
        this.$message.success(res.message)
        this.wallet.canWithdraw = !this.wallet.canWithdraw + 0
      })
    },
    // 获取代理钱包信息
    async getWalletInfo() {
      const { data: res } = await wallet({
        walletUuid: this.walletUuid
      })
      if (res.code !== 200) return this.$message.error(res.message)
      this.wallet = res.data
      // this.getIncomeList()
    },
    // 获取收益明细
    async queryIncomeList() {
      const { data: res } = await statement(this.queryIncome)
      if (res.code !== 200) return this.$message.error(res.message)
      this.incomeList = res.data.entities
      this.totalSizeIncome = res.data.totalSize
    },
    searchIncome() {
      this.queryIncome.curPage = 1
      if (this.periodIncome != null && this.periodIncome !== []) {
        this.queryIncome.ctStart = this.periodIncome[0]
        this.queryIncome.ctEnd = this.periodIncome[1]
      } else {
        this.queryIncome.ctStart = ''
        this.queryIncome.ctEnd = ''
      }
      this.queryIncomeList()
    },
    // 重置按钮点击触发
    custodyIncome() {
      this.period = []
      this.queryIncome = {
        walletUuid: this.walletUuid,
        sourceType: '11',
        curPage: 1,
        pageSize: 10
      }
      this.queryIncomeList()
    },
    // 监听pageSize的变化
    pageSizeChangeIncome(newSize) {
      this.queryIncome.pageSize = newSize
      this.queryIncomeList()
    },
    // 监听当前页码值的变化
    CurrentPageChangeIncome(newPage) {
      this.queryIncome.curPage = newPage
      this.queryIncomeList()
    },
    // 明细导出
    async excelDetail() {
      if (this.periodIncome.length === 0) return this.$message.error('请选择导出的收益明细日期')
      const { data: res } = await excel(this.queryIncome).catch(err => {
        if (err.response) {
          if (err.response.status === 701) {
            return this.$message.error('请筛选后再导出')
          } else if (err.response.status === 702) {
            return this.$message.error('无筛选记录')
          }
        }
        return this.$message.error('系统繁忙，请稍候再试')
      })
      if (!res) {
        return
      }
      let blob = new Blob([res], { type: 'application/vnd.ms-excel' })
      const link = document.createElement('a')
      link.style.display = 'none'
      link.href = URL.createObjectURL(blob)
      link.setAttribute('download', '员工收益明细-' + new Date().getTime() + '.xlsx')
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 8 || columnIndex === 9) {
        return 'background: #f0f9eb;'
      }
    }
  }
}
</script>

<style lang="less" scoped>
.el-card__body {
  padding: 0;
  .el-pagination {
    padding-top: 20px;
  }
}
.el-input,
.el-date-picker,
.el-select {
  width: 160px !important;
}
.el-switch {
  margin-left: 10px;
}
.seachBtn {
  display: inline-block;
  margin-left: 20px;
}
.addProxyForm.el-form {
  .el-form-item {
    .el-input,
    .el-select {
      width: 300px !important;
    }
  }
  .el-button {
    margin-left: 185px;
  }
  p {
    margin-left: 10px;
    font-size: 12px;
    color: red;
  }
}
.mmdRefereeForm {
  .el-form-item {
    .el-input,
    .el-select {
      width: 300px !important;
    }
  }
}
.profitRateForm {
  p {
    margin-left: 10px;
    font-size: 12px;
    color: red;
  }
}
.numberingBox {
  cursor: pointer;
}
.wallet {
  box-sizing: border-box;
  padding: 0 15px;
  .el-breadcrumb {
    font-size: 16px;
  }
  .topBox {
    margin-bottom: 200px;
    div {
      p {
        font-size: 20px;
        font-weight: 700;
        text-align: center;
      }
      .expand {
        .el-form-item {
          margin-right: 0;
          margin-bottom: 0;
          width: 50%;
        }
      }
    }
  }
  .bottom {
    font-size: 20px;
    font-weight: 700;
    text-align: center;
    p {
      margin-bottom: 0;
    }
    .charts {
      margin: 0 auto;
      width: 500px;
      height: 300px;
    }
  }
}
</style>
